/* Afroyla FALL CLEARANCE claim-deal LP — core: 0→target count-up, flip-clock countdown to season end,
 * scroll-reveal for the "catch" value stack, sticky bottom bar visibility, smooth-scroll CTAs, season-ended
 * event. Loaded first (defer); exposes window.AFD consumed by the other claim-deal modules. Needs [data-afd]
 * root rendered by sections/lp-afroyla-fall-clearance-claim-deal.liquid.
 */
(function () {
  var root = document.querySelector('[data-afd]');
  if (!root) return;

  // Ad/signup LP — never indexed
  if (!document.querySelector('meta[name="robots"][data-afd-noindex]')) {
    var m = document.createElement('meta');
    m.name = 'robots'; m.content = 'noindex, nofollow';
    m.setAttribute('data-afd-noindex', '1');
    document.head.appendChild(m);
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seasonEnd = Date.parse(root.dataset.afdSeasonEnd);
  var ended = false;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function markEnded() {
    if (ended) return;
    ended = true;
    root.classList.add('is-ended');
    root.dispatchEvent(new CustomEvent('afd:ended'));
  }
  if (!isNaN(seasonEnd) && Date.now() > seasonEnd) markEnded();

  // ---- 0 → target % count-up (hero), runs once when scrolled into view. Started on demand by
  // window.AFD.startCountup() (claim-arm-swap module, 10-14) so it animates to the resolved per-arm % (60/55). ----
  var countEl = root.querySelector('[data-afd-countup]');
  function startCountup() {
    if (!countEl || countEl.dataset.afdCountupStarted) return;
    countEl.dataset.afdCountupStarted = '1';
    var target = Number(countEl.dataset.afdTarget) || 0;
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true;
        io.disconnect();
        if (reducedMotion) { countEl.textContent = target; return; }
        var start = null, dur = 1200;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          countEl.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    io.observe(countEl);
  }

  // ---- flip-clock countdown + sticky-bar text ----
  var digits = { d: root.querySelector('[data-afd-d]'), h: root.querySelector('[data-afd-h]'), m: root.querySelector('[data-afd-m]'), s: root.querySelector('[data-afd-s]') };
  var barText = root.querySelector('[data-afd-bar-text]');
  var prev = {};
  function setDigit(el, key, val) {
    if (!el) return;
    var txt = pad(val);
    if (prev[key] !== txt) {
      el.textContent = txt;
      if (prev[key] !== undefined && !reducedMotion) { el.classList.remove('is-flip'); void el.offsetWidth; el.classList.add('is-flip'); }
      prev[key] = txt;
    }
  }
  function tickCountdown() {
    if (isNaN(seasonEnd)) return;
    var remain = seasonEnd - Date.now();
    if (remain <= 0) { markEnded(); remain = 0; }
    var s = Math.floor(remain / 1000);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), mi = Math.floor((s % 3600) / 60), se = s % 60;
    setDigit(digits.d, 'd', d); setDigit(digits.h, 'h', h); setDigit(digits.m, 'm', mi); setDigit(digits.s, 's', se);
    if (barText) barText.textContent = 'Limited stock · Ends in ' + d + 'd ' + pad(h) + ':' + pad(mi) + ':' + pad(se);
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  // ---- scroll-reveal: "catch" value-stack list, staggered ----
  var revealList = root.querySelector('[data-afd-reveal]');
  if (revealList) {
    var items = [].slice.call(revealList.children);
    var revealed = false;
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || revealed) return;
        revealed = true;
        rio.disconnect();
        items.forEach(function (li, i) { setTimeout(function () { li.classList.add('is-shown'); }, reducedMotion ? 0 : i * 140); });
      });
    }, { threshold: 0.3 });
    rio.observe(revealList);
  }

  // ---- sticky bottom bar: show once hero scrolls out, hide while the form card is in view ----
  var bar = root.querySelector('[data-afd-bar]');
  var heroEl = root.querySelector('.afd-hero');
  var formCard = root.querySelector('[data-afd-form-card]');
  var heroGone = false, formShown = false;
  function paintBar() { if (bar) bar.classList.toggle('is-shown', heroGone && !formShown); }
  if (bar && heroEl) {
    new IntersectionObserver(function (entries) { heroGone = !entries[0].isIntersecting; paintBar(); }, { threshold: 0 }).observe(heroEl);
  }
  if (bar && formCard) {
    new IntersectionObserver(function (entries) { formShown = entries[0].isIntersecting; paintBar(); }, { threshold: 0.15 }).observe(formCard);
  }

  // ---- "Claim my deal" CTAs → scroll to form card; after season end, send to /collections/all instead ----
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-afd-scrollto]');
    if (!a) return;
    if (ended) { e.preventDefault(); location.href = '/collections/all'; return; }
    var el = document.querySelector(a.getAttribute('href'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  window.AFD = { root: root, reducedMotion: reducedMotion, esc: esc, isEnded: function () { return ended; }, seasonEnd: seasonEnd, startCountup: startCountup };
})();
